import { Instagram, Linkedin } from "lucide-react";
import { Link } from "react-router-dom";
import { useLeadModal } from "@/context/LeadModalContext";
import { openCookiePreferences } from "@/lib/consent";
import { trackContact } from "@/lib/meta";

export const Footer = () => {
  const { openModal } = useLeadModal();
  return (
    <footer className="bg-richblack text-taupe pt-20 pb-12" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="grid md:grid-cols-[1.4fr_1fr_1fr] gap-12 border-b hairline-light pb-16">
          <div>
            <img src="/logo-mbo-white.png" alt="My Brand Online" className="h-6 w-auto mb-6" data-testid="footer-logo" />
            <p className="font-display italic text-3xl sm:text-4xl text-ivory/90 leading-tight max-w-md">
              L'infrastruttura dietro il tuo brand.
            </p>
            <button
              onClick={openModal}
              className="mt-8 inline-flex items-center bg-ivory text-ink px-8 py-4 text-[11px] tracking-mega font-medium hover:bg-goldtan transition-colors duration-300"
            >
              RICHIEDI ACCESSO
            </button>
          </div>

          <div>
            <p className="font-sans-ui text-[10px] tracking-mega text-taupe/60 mb-5">SEDE</p>
            <p className="font-sans-ui text-sm text-ivory/80 leading-relaxed">
              My Brand Online S.L.<br />Valencia, España
            </p>
            <div className="flex gap-4 mt-6">
              <a href="#top" aria-label="Instagram" data-testid="footer-contact-instagram" onClick={() => trackContact("instagram")} className="text-taupe/70 hover:text-ivory transition-colors"><Instagram size={18} /></a>
              <a href="#top" aria-label="LinkedIn" data-testid="footer-contact-linkedin" onClick={() => trackContact("linkedin")} className="text-taupe/70 hover:text-ivory transition-colors"><Linkedin size={18} /></a>
            </div>
          </div>

          <div>
            <p className="font-sans-ui text-[10px] tracking-mega text-taupe/60 mb-5">LEGALE</p>
            <ul className="space-y-3 font-sans-ui text-sm">
              <li><Link to="/privacy" data-testid="footer-privacy-link" className="text-ivory/75 hover:text-ivory transition-colors">Privacy Policy</Link></li>
              <li><Link to="/cookie-policy" data-testid="footer-cookie-policy-link" className="text-ivory/75 hover:text-ivory transition-colors">Cookie Policy</Link></li>
              <li><Link to="/termini" data-testid="footer-terms-link" className="text-ivory/75 hover:text-ivory transition-colors">Termini di utilizzo</Link></li>
              <li>
                <button
                  data-testid="footer-manage-cookies"
                  onClick={openCookiePreferences}
                  className="text-ivory/75 hover:text-ivory transition-colors"
                >
                  Gestisci cookie
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row justify-between gap-3 font-sans-ui text-[11px] tracking-wide text-taupe/50">
          <span>© {new Date().getFullYear()} My Brand Online S.L. — Tutti i diritti riservati.</span>
          <span>Fashion Infrastructure · Private Label · Fulfillment · Europa</span>
        </div>
      </div>
    </footer>
  );
};
